var _g, _g2, _path, _path2, _g3, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBridge1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 872,
    height: 570,
    viewBox: "0 0 872 570",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_196_3423)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.33186e-05 285C2.64384e-05 442.401 51.0396 570 114 570C176.96 570 228 442.401 228 285C228 127.599 176.96 -2.23101e-06 114 -4.9831e-06C51.0396 -7.73519e-06 4.01988e-05 127.599 3.33186e-05 285Z",
    fill: "url(#paint0_linear_196_3423)",
    fillOpacity: 0.05
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_b_196_3423)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M89.0004 285.34C89.0004 410.897 129.781 512.681 180.087 512.681C230.393 512.681 271.174 410.897 271.174 285.34C271.174 159.783 230.393 57.9994 180.087 57.9994C129.781 57.9994 89.0004 159.783 89.0004 285.34Z",
    fill: "url(#paint1_linear_196_3423)",
    fillOpacity: 0.16
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.2
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M361.372 285.34C361.372 406.437 323.443 505.396 275.62 512.281C277.386 512.544 279.169 512.677 280.954 512.681C331.268 512.681 372.041 410.902 372.041 285.34C372.041 159.779 331.268 57.9995 280.954 57.9995C279.169 58.0031 277.386 58.1366 275.62 58.399C323.443 65.2846 361.372 164.338 361.372 285.34Z",
    fill: "black"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M333.69 431.768C350.657 396.776 361.42 344.394 361.42 285.832C361.42 227.269 350.657 174.911 333.69 139.919L333.69 95.0808L282.788 95.0808C240.089 96.0208 205.567 181.044 205.567 285.808C205.567 390.572 240.089 475.619 282.788 476.559L333.69 476.559L333.69 431.768Z",
    fill: "url(#paint2_linear_196_3423)",
    fillOpacity: 0.84
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_b_196_3423)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M255.974 285.833C255.974 391.194 290.768 476.607 333.689 476.607C376.61 476.607 411.404 391.194 411.404 285.833C411.404 180.471 376.61 95.0581 333.689 95.0581C290.768 95.0581 255.974 180.471 255.974 285.833Z",
    fill: "url(#paint3_linear_196_3423)",
    fillOpacity: 0.16
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M272.588 285.338C272.588 378.188 300.575 453.458 335.099 453.458C369.623 453.458 397.609 378.188 397.609 285.338C397.609 192.488 369.623 117.218 335.099 117.218C300.575 117.218 272.588 192.488 272.588 285.338Z",
    fill: "#FCFAFF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M361.442 368.787C371.077 348.929 377.187 319.178 377.187 285.925C377.187 252.673 371.077 222.945 361.442 203.087L361.442 177.542L332.561 177.542C308.308 178.083 288.709 226.352 288.709 285.831C288.709 345.31 308.308 393.603 332.561 394.144L361.442 394.144L361.442 368.787Z",
    fill: "url(#paint4_linear_196_3423)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    }
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M290.026 285.831C290.026 226.352 309.601 178.083 333.853 177.542L332.561 177.542C308.309 178.083 288.71 226.352 288.71 285.831C288.71 345.31 308.309 393.603 332.561 394.144L333.9 394.144C309.601 393.603 290.026 345.287 290.026 285.831Z",
    fill: "black"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M317.31 285.833C317.31 345.652 337.069 394.145 361.443 394.145C385.817 394.145 405.576 345.652 405.576 285.833C405.576 226.014 385.817 177.521 361.443 177.521C337.069 177.521 317.31 226.014 317.31 285.833Z",
    fill: "url(#paint5_linear_196_3423)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M326.758 285.554C326.758 338.274 342.656 381.012 362.267 381.012C381.878 381.012 397.775 338.274 397.775 285.554C397.775 232.834 381.878 190.096 362.267 190.096C342.656 190.096 326.758 232.834 326.758 285.554Z",
    fill: "#FCFAFF"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M318.931 285.835C318.931 226.685 338.248 178.627 362.266 177.57C361.984 177.57 361.725 177.57 361.443 177.57C337.073 177.57 317.31 226.051 317.31 285.858C317.31 345.666 337.073 394.171 361.443 394.171C361.725 394.171 361.984 394.171 362.266 394.171C338.248 393.066 318.931 345.008 318.931 285.835Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M872 117.372L334.513 117.372C299.991 117.372 272.002 192.573 272.002 285.493C272.002 378.412 299.991 453.425 334.513 453.425L872 453.425L872 117.372Z",
    fill: "url(#paint6_linear_196_3423)",
    fillOpacity: 0.08
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_196_3423",
    x: -22.1053,
    y: -22.1053,
    width: 272.211,
    height: 614.211,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 11.0526
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_196_3423"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_196_3423",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_b_196_3423",
    x: 66.8947,
    y: 35.8941,
    width: 226.384,
    height: 498.892,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 11.0526
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_196_3423"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_196_3423",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_b_196_3423",
    x: 233.869,
    y: 72.9528,
    width: 199.64,
    height: 425.759,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 11.0526
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_196_3423"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_196_3423",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_196_3423",
    x1: 25.7208,
    y1: 588.049,
    x2: 368.963,
    y2: 98.9188,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0A3EFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3FF4E8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_196_3423",
    x1: 109.551,
    y1: 527.078,
    x2: 383.197,
    y2: 136.48,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0A3EFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3FF4E8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_196_3423",
    x1: 202.302,
    y1: 285.319,
    x2: 418.807,
    y2: 238.768,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1735A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.685839,
    stopColor: "#099B91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_196_3423",
    x1: 273.508,
    y1: 488.689,
    x2: 501.814,
    y2: 157.355,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0A3EFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3FF4E8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_196_3423",
    x1: 332.96,
    y1: 177.542,
    x2: 332.96,
    y2: 394.144,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1F2FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E2E6F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_196_3423",
    x1: 361.443,
    y1: 177.544,
    x2: 361.443,
    y2: 394.145,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2F0FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F4F3FB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_196_3423",
    x1: 363.183,
    y1: 452.54,
    x2: 872,
    y2: 452.54,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0A3EFF",
    stopOpacity: 0.81
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3FF4E8",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBridge1);
export default __webpack_public_path__ + "static/media/bridge-1.2f94687c87e74f31aea245c1e471ccab.svg";
export { ForwardRef as ReactComponent };